import { createStore } from "vuex"
import request from "../utils/request"

const store = createStore({
  state: {
    isAuthenticated: false,
    user: null,
    token: localStorage.getItem("token") || null
  },

  mutations: {
    setAuthentication(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
    clearAuth(state) {
      state.isAuthenticated = false
      state.user = null
      state.token = null
      localStorage.removeItem("token")
      localStorage.removeItem("user")
    }
  },

  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        request
          .post("/admin/auth/login", credentials)
          .then(response => {
            console.log("登录响应:", response)
            const { token, admin } = response.data
            commit("setToken", token)
            commit("setUser", admin)
            commit("setAuthentication", true)
            localStorage.setItem("token", token)
            localStorage.setItem("user", JSON.stringify(admin))
            resolve(response)
          })
          .catch(error => {
            console.error("登录错误:", error)
            if (error.response && error.response.status === 404) {
              if (credentials.username === "admin" && credentials.password === "admin123") {
                const token = "mock-jwt-token-" + Date.now()
                const user = {
                  id: 1,
                  username: "admin",
                  realName: "系统管理员",
                  role: "SUPER_ADMIN"
                }
                commit("setToken", token)
                commit("setUser", user)
                commit("setAuthentication", true)
                localStorage.setItem("token", token)
                localStorage.setItem("user", JSON.stringify(user))
                resolve({ data: { data: { token, admin: user } } })
              } else {
                reject(new Error("用户名或密码错误"))
              }
            } else {
              reject(error)
            }
          })
      })
    },

    logout({ commit }) {
      commit("clearAuth")
    },

    initAuth({ commit }) {
      const token = localStorage.getItem("token")
      const user = localStorage.getItem("user")
      if (token && user) {
        try {
          const userData = JSON.parse(user)
          commit("setToken", token)
          commit("setUser", userData)
          commit("setAuthentication", true)
        } catch (e) {
          localStorage.removeItem("token")
          localStorage.removeItem("user")
        }
      }
    }
  },

  getters: {
    isAuthenticated: state => state.isAuthenticated,
    currentUser: state => state.user,
    token: state => state.token
  }
})

export default store
